import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { EmployeeRank } from '../../../models/employee/EmployeeRank';
import { EmployeeRankResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An Adapter converts employee rank HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeRankAdapter implements Adapter<EmployeeRank[]> {

  /**
   * Converts employee rank HTTP response to a list of {@link EmployeeRank}.
   * @param item employee rank HTTP response.
   */
  adapt(item: EmployeeRankResponse[]): EmployeeRank[] {
    if (!item) {
      return [];
    }
    const result: EmployeeRank[] = [];
    item.forEach($item => result.push(new EmployeeRank($item.rank, $item.date)));
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
